var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useEffect, useMemo, useState } from "react";
import { getBusinessReportDailyWithCache } from '../../../utils/businessReportDailyCache';
import { buildStoreOverviewSnapshot, enrichStoreOverviewFromReportList, } from '../../../utils/buildStoreOverviewSnapshot';
export function useStoreOverviewData(storeId, roomRows, options) {
    var enabled = (options === null || options === void 0 ? void 0 : options.enabled) !== false;
    var _a = useState(null), reportRow = _a[0], setReportRow = _a[1];
    var _b = useState([]), reportList = _b[0], setReportList = _b[1];
    var _c = useState(enabled), loading = _c[0], setLoading = _c[1];
    var _d = useState(null), error = _d[0], setError = _d[1];
    useEffect(function () {
        if (!enabled) {
            setLoading(false);
            setError(null);
            setReportList([]);
            setReportRow(null);
            return;
        }
        var cancelled = false;
        setLoading(true);
        setError(null);
        getBusinessReportDailyWithCache(storeId)
            .then(function (list) {
            if (cancelled)
                return;
            var arr = list || [];
            setReportList(arr);
            var sorted = __spreadArray([], arr, true).sort(function (a, b) { return (b.date || 0) - (a.date || 0); });
            var row = sorted[0];
            setReportRow(row && typeof row === "object"
                ? row
                : null);
        })
            .catch(function (e) {
            if (!cancelled) {
                setError(e instanceof Error ? e : new Error(String(e)));
                setReportRow(null);
            }
        })
            .finally(function () {
            if (!cancelled)
                setLoading(false);
        });
        return function () {
            cancelled = true;
        };
    }, [storeId, enabled]);
    var snapshot = useMemo(function () {
        var base = buildStoreOverviewSnapshot(reportRow, roomRows !== null && roomRows !== void 0 ? roomRows : []);
        return enrichStoreOverviewFromReportList(reportList, base);
    }, [reportRow, roomRows, reportList]);
    return {
        snapshot: snapshot,
        loading: loading,
        error: error,
    };
}
